import React, { useContext, useState } from "react";
import { PostPurchaseContext, PostPurchaseDispatchContext } from "../../context/PostPurchaseContext";
import BuyAKit from "../BuyAKit";
import NextButton from "../NextButton";
import BackButton from "../BackButton";
import Popup from "../Popup";
import NoFilters from "../NoFilters";
import PurchaseSeparately from "../PurchaseSeparately";

function Step3() {
  const state = useContext(PostPurchaseContext);
  const dispatch = useContext(PostPurchaseDispatchContext);
  const kitData = state.kitData;
  const filtersData = state.filtersData;

  const [showPopup, setShowPopup] = useState(false)

  function handleNext() {
    if (kitData && filtersData && !state.cart.kit && state.cart.filters.length < filtersData.length) {
      setShowPopup(true)
      return;
    }
    dispatch({ type: "setActiveStep", payload: 4 })
  }

  return (
    <>
      {(kitData && filtersData) ?
        <>
          <BuyAKit kit={kitData} />
          <PurchaseSeparately filters={filtersData} />
          <div class="button-wrapper">
          <BackButton text="Back" isLoading={false} />
          <NextButton handler={handleNext} text={!state.cart.kit && state.cart.filters.length === 0 ? "No Thanks" : "Next"} isLoading={false} />
          </div>
        </> 
        :
        <>
          <NoFilters />
          <div class="button-wrapper">
          <BackButton isLoading={false} text="Back" />
          <NextButton handler={handleNext} text="Next" isLoading={false}/>
          </div>
        </>
      } 
      {showPopup && (
        <Popup
          setShowPopup={setShowPopup}
          actionBtns={true}
          extraClasses="bg-brio-100"
          message={
            "You did not add a complete set of filters to your cart. In order to function properly, ALL filters in your water cooler must be replaced routinely. Do you still want to continue?"
          }
        />
      )}
    </>
  );
}

export default Step3;
